
import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { CleverTapConstents } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-institutes',
  templateUrl: './institutes.component.html',
  styleUrls: ['./institutes.component.scss']
})
export class InstitutesComponent implements OnInit {

  instituteList: any = [];

  selectedLocation: any = '';

  filteredInstituteList: any[] = [];

  totalPages: number = 0;

  currentPage: number = 0;

  searchTerm: string = '';

  constructor(public util: UtilService) { }

  public searchTerms = new Subject<string>();

  isSF: boolean = false;

  isLessElements: boolean = false;




  ngOnInit(): void {
    this.init()
    this.util.updatedDataInstitue.subscribe(() => {
      this.init()

    })

  }

  init() {
    this.isSF = this.util.getCache('selectedCatogory') == 'EL_SF';
    if (!this.util.getCache("instituteList")) {
      if (localStorage.getItem('cat'))
        this.util.loadProduct(JSON.parse(localStorage.getItem('product') || '{}'), JSON.parse(localStorage.getItem('cat') || '{}'), JSON.parse(localStorage.getItem('lat') || '{}'), JSON.parse(localStorage.getItem('lng') || '{}'));
      else
        this.util.route('home');
    }else{
      this.isLessElements = (this.isSF?this.util.getCache("instituteList")?.length: this.util.getCache("instituteList")?.totalElements) <= 3;
      this.instituteList = this.isSF ? this.util.getCache("instituteList")  :  this.util.getCache("instituteList")?.content;
      this.selectedLocation = `${this.instituteList[0]?.city}, ${this.instituteList[0]?.state}`;
      this.totalPages =  this.isSF ? Math.ceil(this.util.getCache("instituteList")?.length / 6) : Math.ceil(this.util.getCache("instituteList")?.totalElements / this.util.getCache("instituteList")?.pageSize);
       this.isSF ? " " : this.searchInstitutes();
    }
  }

  openDrop(id: string) {
    $('#' + id).toggleClass('open').parent('.cus-dropdown').toggleClass('opened');
  }

  selectLocation(city: any, isDrop: boolean = true) {
    if (isDrop) {
      this.selectedLocation = `${city?.value}, ${city.stateInfo?.value}`
    } else {
      this.selectedLocation = city;
    }
    this.getFilterInstitutes(city)
  }


  searchInstitutes() {
    this.searchTerms
      .pipe(
        debounceTime(800),
        distinctUntilChanged(),
        switchMap(searchTerm => this.util.handleRequests('get', this.util.getUrl('courses_v2_all', [searchTerm, this.util.getCache('selectedCatogory'), 0, 6])))
      ).subscribe(res => {
        this.instituteList = res.content;
        this.totalPages = Math.ceil(res.totalElements / res.pageSize);
      });

  }


  onInputChange() {
    this.currentPage = 0;
    this.searchTerms.next(this.searchTerm);
  }



  getFilterInstitutes(city: any): void {
    // this.filteredInstituteList = this.instituteList.filter((course: any) => {
    //   return (`${course.city}, ${course.state}`).toLowerCase().includes(this.selectedLocation.toLowerCase())
    // });
    let params = { "schoolName": "", "city": city?.value, "state": city.stateInfo?.value, "lat": "", "lng": "" };
    const base64Str = btoa(JSON.stringify(params));
    this.util.handleRequests('get', this.util.getUrl('school_filter', [base64Str])).then(res => {
      this.filteredInstituteList = res.content?.nearBySchool;
      if(this.filteredInstituteList){
        this.instituteList = this.filteredInstituteList
        this.totalPages = Math.ceil(res.content.nearBySchool?.length / 6);
        this.currentPage = 0;

      }
    });

  }


  openCourses(institute: any, i: any) {
    this.util.handleRequests('get', this.util.getUrl('courses_courses', ['', institute.id, 0, 6])).then(res => {
      this.util.setCache('currentInstituteCourses', res);
      this.util.setCache('currentInstitute', institute);
      localStorage.setItem('currentInstituteCourses', JSON.stringify(res));
      localStorage.setItem('currentInstitute', JSON.stringify(institute));
      this.util.route('courses')
    });
    // this.util.setCache('currentInstituteCourses', this.util.getCache("instituteList")[i].courses);
  }

  back() {
    this.util.clearInstitudeData();
    this.util.route('home');
   
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getInstitutes();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.getInstitutes();
    }
  }

  studentDetail(institute1: any, i: any) {

    const institute = this.util.getCache('selectedCatogory')
    const product = this.util.getCache('product');

    this.util.handleRequests('post', this.util.getUrl('loan_create'), {
      product: product.id,
      productCategory: institute,
      fromQR: false,
    }).then((loan: any) => {
      this.util.handleRequests('put', this.util.getUrl('institute_select', [loan.content.loanId]), {
        centerId: institute1.id,
        courseId: null,
      }).then((res: any) => {
        this.util.getLoandetails().then(() => {
          this.util.route('studentDetails');
        });
      this.util.cleverTapEventCall(CleverTapConstents.select_institue,{
        'centerId': institute1.id,
      });
      })
    });
  }

  getInstitutes() {
    this.util.handleRequests('get', this.util.getUrl('courses_v2_all', [this.searchTerm, this.util.getCache('selectedCatogory'), this.currentPage, 6])).then(res => {
      this.instituteList = res.content;
      this.totalPages = Math.ceil(res.totalElements / res.pageSize)
    });
  }

}
